import { feeCalcOf, type PosCustomFeeType } from '@mlm/shared';

/**
 * The fee rules for one POS payment method's list, as a message or null. The
 * page prefixes the method's label, since every method card carries its own
 * list. Kept out of `method-fees-editor.tsx` so that file exports only
 * components (react-refresh).
 */
export function validateMethodFees(fees: PosCustomFeeType[]): string | null {
  const codes = fees.map((t) => t.code.trim());
  if (codes.some((c) => c === '')) return 'Every fee needs a code.';
  if (codes.some((c) => !/^[a-z0-9_]+$/.test(c)))
    return 'Fee codes must be lowercase letters, digits, or underscores.';
  if (new Set(codes).size !== codes.length) return 'Fee codes must be unique.';
  if (fees.some((t) => t.label.trim() === '')) return 'Every fee needs a label.';
  if (
    fees.some((t) => {
      const c = feeCalcOf(t);
      return c.kind !== 'manual' && !(c.value > 0);
    })
  )
    return 'A percentage or fixed fee needs a rate above zero.';
  if (
    fees.some((t) => {
      const c = feeCalcOf(t);
      return c.kind === 'percent' && c.value > 100;
    })
  )
    return 'A percentage fee cannot exceed 100%.';
  return null;
}
